import type { BackofficeRole } from '@/contexts/BackofficeAuthContext';

export interface EmpresaUsuario {
  userId: string;
  empresaId: string;
  role: BackofficeRole;
}

// Associação usuário-empresa: define quais usuários acessam quais empresas e com qual papel
export const empresaUsuarios: EmpresaUsuario[] = [
  // Admin tem acesso a TODAS as empresas
  { userId: 'adm-001', empresaId: 'EMP-001', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-002', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-003', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-004', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-005', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-006', role: 'admin' },
  { userId: 'adm-001', empresaId: 'EMP-007', role: 'admin' },

  // Ana Souza (suporte) - empresas ativas principais
  { userId: 'sup-001', empresaId: 'EMP-001', role: 'suporte' },
  { userId: 'sup-001', empresaId: 'EMP-002', role: 'suporte' },
  { userId: 'sup-001', empresaId: 'EMP-003', role: 'operador' },

  // Carlos Mendes (financeiro) - empresas com movimentação financeira
  { userId: 'fin-001', empresaId: 'EMP-001', role: 'financeiro' },
  { userId: 'fin-001', empresaId: 'EMP-002', role: 'financeiro' },
  { userId: 'fin-001', empresaId: 'EMP-004', role: 'operador' },

  // Mariana Lima (operador) - acesso limitado
  { userId: 'op-001', empresaId: 'EMP-001', role: 'operador' },
  { userId: 'op-001', empresaId: 'EMP-004', role: 'operador' },
];

export function getEmpresasByUserId(userId: string): EmpresaUsuario[] {
  return empresaUsuarios.filter(eu => eu.userId === userId);
}

export function getEmpresaIdsByUserId(userId: string): string[] {
  return empresaUsuarios
    .filter(eu => eu.userId === userId)
    .map(eu => eu.empresaId);
}

export function getUsuariosByEmpresaId(empresaId: string): EmpresaUsuario[] {
  return empresaUsuarios.filter(eu => eu.empresaId === empresaId);
}

export function getRoleNaEmpresa(userId: string, empresaId: string): BackofficeRole | null {
  const eu = empresaUsuarios.find(
    e => e.userId === userId && e.empresaId === empresaId
  );
  return eu ? eu.role : null;
}

export function temAcessoEmpresa(userId: string, empresaId: string): boolean {
  return empresaUsuarios.some(
    e => e.userId === userId && e.empresaId === empresaId
  );
}

// Mutations simuladas (alteram o array em memória, simulando uma API)
export function adicionarUsuarioEmpresa(userId: string, empresaId: string, role: BackofficeRole): void {
  const existente = empresaUsuarios.findIndex(
    e => e.userId === userId && e.empresaId === empresaId
  );
  if (existente >= 0) {
    empresaUsuarios[existente].role = role;
  } else {
    empresaUsuarios.push({ userId, empresaId, role });
  }
}

export function removerUsuarioEmpresa(userId: string, empresaId: string): void {
  const idx = empresaUsuarios.findIndex(
    e => e.userId === userId && e.empresaId === empresaId
  );
  if (idx >= 0) {
    empresaUsuarios.splice(idx, 1);
  }
}